import React, { FC } from 'react'
import ListPageLayout from '@templates/ListPageLayout'
import useReports from '@hooks/useReports'
import ReportsTable from './ReportsTable'

const Reports: FC = () => {
  const { data, ...rest } = useReports()
  const { items = [], length = 0 } = data || {}

  return (
    <ListPageLayout
      {...rest}
      titleTabs={[
        {
          title: 'Отчеты',
          counter: length,
          index: 0,
        },
      ]}
      ListComponent={ReportsTable}
      list={items}
      length={length}
    />
  )
}

export default Reports
